export var AnswerType;

(function (AnswerType) {
  AnswerType["Essay"] = "1";
  AnswerType["SingleChoice"] = "2";
  AnswerType["MultipleChoice"] = "3";
  AnswerType["FillInBlank"] = "4";
  AnswerType["Matching"] = "5";
  AnswerType["Speaking"] = "6";
})(AnswerType || (AnswerType = {}));